export const shareHasDownloadableContent = (share: {
  extraVariants?: Array<unknown> | null;
  downloadableVariants?: Array<unknown> | null;
  includeOriginalFile?: boolean | null;
}): boolean =>
  Boolean(share.extraVariants?.length) ||
  Boolean(share.downloadableVariants?.length) ||
  Boolean(share.includeOriginalFile);
